/**
 * Utgående e-post per kundtoppnod. Saknad nyckel betyder att mailet går ut.
 * Nycklarna ska matcha backend OrganizationEmailKind.
 */

export const ORGANIZATION_EMAIL_KINDS = [
  'bookingConfirmation',
  'bookingOverdue',
  'bookingCancellation',
  'bookingAssignment',
  'welcome',
  'passwordReset',
  'emailVerification',
  'drivingLog',
  'vehicleDue',
  'service',
  'unplug',
  'rentalReport',
  'travelPlanner',
  'scheduledReport',
  'supportReply',
] as const;

export type OrganizationEmailKind = (typeof ORGANIZATION_EMAIL_KINDS)[number];
export type OrganizationEmailSettings = Record<OrganizationEmailKind, boolean>;

export function defaultOrganizationEmailSettings(): OrganizationEmailSettings {
  return {
    bookingConfirmation: true,
    bookingOverdue: true,
    bookingCancellation: true,
    bookingAssignment: true,
    welcome: true,
    passwordReset: true,
    emailVerification: true,
    drivingLog: true,
    vehicleDue: true,
    service: true,
    unplug: true,
    rentalReport: true,
    travelPlanner: true,
    scheduledReport: true,
    supportReply: true,
  };
}

function parseFlag(value: unknown): boolean {
  if (value === false || value === 0 || value === '0' || value === 'false') return false;
  return true;
}

export function mergeOrganizationEmailSettings(raw: unknown): OrganizationEmailSettings {
  const defaults = defaultOrganizationEmailSettings();
  if (raw == null || raw === '') return defaults;
  let value: unknown = raw;
  if (typeof raw === 'string') {
    try {
      value = JSON.parse(raw);
    } catch {
      return defaults;
    }
  }
  if (typeof value !== 'object' || value === null) return defaults;
  const obj = value as Partial<Record<OrganizationEmailKind, unknown>>;
  const out = defaultOrganizationEmailSettings();
  for (const kind of ORGANIZATION_EMAIL_KINDS) {
    if (obj[kind] !== undefined) out[kind] = parseFlag(obj[kind]);
  }
  return out;
}
